import { TDay } from '../../api/getMenu/types';
import { DAYS } from 'src/constants';
export const getDayIndex = (day: TDay): number => {
  return DAYS.indexOf(day) + 1;
};

// day of week 1 = MONDAY ... 7 = SUNDAY
export const getDay = (dayOfWeek: number): TDay => {
  return DAYS[dayOfWeek - 1];
};
